/** Reserve the tab during the user gesture, before an authenticated fetch awaits. */
export async function openPdfForPrint(
  load: () => Promise<Blob>,
  messages: { loading: string; failed: string }
): Promise<void> {
  const viewer = window.open("", "_blank");
  if (!viewer) throw new Error("PDF popup blocked");

  viewer.document.title = messages.loading;
  viewer.document.body.textContent = messages.loading;

  let releasePdf: (() => void) | undefined;
  try {
    const blob = await load();
    if (!blob.size || !blob.type.toLowerCase().startsWith("application/pdf")) {
      throw new Error("Expected a PDF");
    }

    const url = URL.createObjectURL(blob);
    const cleanup = () => {
      window.clearInterval(closeCheck);
      URL.revokeObjectURL(url);
      window.removeEventListener("pagehide", cleanup);
    };
    const closeCheck = window.setInterval(() => {
      if (viewer.closed) cleanup();
    }, 5_000);
    releasePdf = cleanup;
    window.addEventListener("pagehide", cleanup);
    viewer.location.replace(url);
  } catch (error) {
    releasePdf?.();
    if (!viewer.closed) {
      viewer.document.title = messages.failed;
      viewer.document.body.textContent = messages.failed;
    }
    throw error;
  }
}
